<template>
  <gradient-background>
    <center-card>
      <template v-slot:card-title>
        {{$t('general.notFound')}}
      </template>
    </center-card>
  </gradient-background>
</template>

<script>
  import GradientBackground from '../layouts/general/GradientBackground.vue';
  import CenterCard from '../layouts/cards/CenterCard.vue';

  export default {
    components: {
      GradientBackground,
      CenterCard,
    },
  };
</script>
